var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"profile-container tw-col-span-3"},[_c('profile-edit')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }